import Sharing from './Sharing';

export default Sharing;
